// extracted by mini-css-extract-plugin
export default {"modal-backdrop":"style_modal-backdrop__SCz2X","modal-content-wrapper":"style_modal-content-wrapper__KWqu1"};